import React from "react";
import { Link } from "react-router-dom";
import i1 from "../../assets/banner/1.png";
import i2 from "../../assets/banner/2.png";
import "./esentail.css";

function Essential() {
  return (
    <>
      <div className="essential">
        <p>Essential For You</p>
        {" "}
        <Link href="">
          <img src={i1} alt="" />
        </Link>
        <Link href="">
          <img src={i2} alt="" />
        </Link>
      </div>
    </>
  );
}

export default Essential;
